import "../styles/GoogleSignIn.scss";

function GoogleSignIn() {
  function handleClickOnSignInBtn() {
    const serverURL = process.env.REACT_APP_SERVER_URL;
    let url = `${serverURL}/api/auth/google`;
    window.open(url, "_self");
  }

  return (
    <div className="google-sign-in">
      <button className="google-sign-in__btn" onClick={handleClickOnSignInBtn}>
        Sign In With Google
      </button>
    </div>
  );
}

export default GoogleSignIn;
